import GroupsFilter from "./GroupsFilter"

export default  GroupsFilter;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/GroupsFilter/index.js